// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contragents_invalidList__rCSPq {
  margin-top: 30px;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: start;
  justify-content: space-between;
}
.Contragents_invalidList__title__9PxZ5 {
  margin: 0;
  padding: 0;
  font-family: Raleway;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  text-transform: none;
  font-feature-settings: "lnum";
  color: #ff0000;
  margin-top: 12px;
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.Contragents_invalidList__item__AV-e2 {
  list-style: none;
}
.Contragents_invalidList__item__AV-e2 textarea {
  width: 300px;
  height: 300px;
  background-color: transparent;
  border-color: transparent;
  font-family: Raleway;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.4375em;
  text-transform: none;
  font-feature-settings: "lnum";
  color: #ff0000;
  box-sizing: border-box;
  position: relative;
  cursor: text;
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-top: 5px;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Contragents.module.scss","webpack://./src/constants/_colors.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AADJ;AAEI;EACI,SAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;EACA,cCZF;EDaE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AACQ;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,cChCN;EDiCM,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AACZ","sourcesContent":["@import '@/constants/colors';\n\n.invalidList {\n    margin-top: 30px;\n    width: 100%;\n    padding: 0;\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n    &__title {\n        margin: 0;\n        padding: 0;\n        font-family: Raleway;\n        font-weight: 400;\n        font-size: 1rem;\n        line-height: 1.5;\n        text-transform: none;\n        font-feature-settings: \"lnum\";\n        color: $red;\n        margin-top: 12px;\n        margin-bottom: 12px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n    }\n    &__item {\n        list-style: none;\n        textarea {\n            width: 300px;\n            height: 300px;\n            background-color: transparent;\n            border-color: transparent;\n            font-family: Raleway;\n            font-weight: 400;\n            font-size: 1rem;\n            line-height: 1.4375em;\n            text-transform: none;\n            font-feature-settings: \"lnum\";\n            color: $red;\n            box-sizing: border-box;\n            position: relative;\n            cursor: text;\n            display: inline-flex;\n            align-items: center;\n            position: relative;\n            margin-top: 5px;\n            resize: none; \n\n        }\n    }\n}\n","$black: #000000;\n$white: #ffffff;\n$grey: #6e6e6e;\n$slightly_grey: #e6e6e6;\n$light-gray: #def3db;\n$gray_smoke: #bdbdbd;\n$red: #ff0000;\n$heavenly: #61dafb;\n$granite_grey: #282c34;\n$periwinkle_crayola: #f1f9f7;\n$pale_blue: #d7d7d8;\n$dull_grey: #616161;\n$emerald: #5dc689;\n$light_green: #1dc255;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invalidList": `Contragents_invalidList__rCSPq`,
	"invalidList__title": `Contragents_invalidList__title__9PxZ5`,
	"invalidList__item": `Contragents_invalidList__item__AV-e2`
};
export default ___CSS_LOADER_EXPORT___;
